module.exports = __webpack_public_path__ + "coffee_icon.png?f50926a64e5919b53e61ae06a32c9b3e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-icons/coffee_icon.png
// module id = 8
// module chunks = 0